const extractSiteName = (referrerURL: string, referringSites: string[]): string => {
  const site = referringSites.find(site => referrerURL.includes(site))
  return site ?? ''
}

export default extractSiteName
